import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

const Image = styled.img`
  display: block;
  height: 100%;
  object-fit: cover;
  width: 100%;
  opacity: ${({ isLoading }) => (isLoading ? 0 : 1)};
  transition: opacity 0.6s ease-in-out;
`;

const AspectRatioContainer = styled.span`
  display: block;
  overflow: hidden;
  padding-bottom: ${((9 / 16) * 100)}%;
  position: relative;
`;

const ContainerFill = styled.span`
  height: 100%;
  position: absolute;
  width: 100%;
`;

const ResponsiveImage = ({ alt, children, ...props }) => {
  const [isLoading, setLoading] = useState(true);

  return (
    <AspectRatioContainer>
      <ContainerFill>
        <Image alt={alt} loading="lazy" isLoading={isLoading} onLoad={() => setLoading(false)} {...props} />
        {children}
      </ContainerFill>
    </AspectRatioContainer>
  );
};

ResponsiveImage.defaultProps = {
  children: undefined,
  alt: '',
};

ResponsiveImage.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  alt: PropTypes.string,
};

export default ResponsiveImage;
